import { useState } from "react"
import { PlanRoot } from "library/tree/constants.mjs"
import { BoundDatePicker } from "lib/@components/datePicker"
import { Box, IconButton, InputAdornment, Typography } from "@mui/material"
import { confirm } from "lib/@dialogs/confirm"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { isInPublishedRegime } from "routes/facilities/lib/when-parent-item"
import { If } from "lib/@components/switch"

export function PlanDate({ sx }) {
    const { parentItem, isRegimeDraftLocked } = useBoundContext()
    const [isLocked, setLocked] = useState(true)
    const allowChange = isInPublishedRegime(parentItem) || !isRegimeDraftLocked
    return (
        parentItem[PlanRoot] && (
            <Box sx={{ mt: 2, ...sx }}>
                <BoundDatePicker
                    readOnly={isLocked}
                    textFieldProps={{
                        size: "small",
                        readOnly: isLocked,
                        InputProps: {
                            startAdornment: (
                                <If truthy={allowChange}>
                                    <InputAdornment position="start">
                                        <IconButton
                                            aria-label={
                                                isLocked ? "Unlock start date" : "Unlock start date (already unlocked)"
                                            }
                                            aria-disabled={!isLocked}
                                            onClick={unlock}
                                            size="small"
                                            color={isLocked ? "secondary" : "success"}
                                        >
                                            {isLocked ? <Iconify icon="mdi:lock" /> : <Iconify icon="mdi:lock-open" />}
                                        </IconButton>
                                    </InputAdornment>
                                </If>
                            ),
                        },
                    }}
                    field="date"
                    transformOut={(v) => new Date(v).addHours(2)}
                    label="Start Date"
                />
            </Box>
        )
    )

    async function unlock() {
        if (!isLocked) return
        if (
            await confirm(
                <Box>
                    <Typography variant="inherit" gutterBottom>
                        You don&apos;t need to move the plan start date to view the plan for other years.
                    </Typography>
                    <Typography variant="inherit" gutterBottom>
                        The plan start date is just the first day on which tasks are allocated for the first time.
                    </Typography>
                    <Typography variant="body1" sx={{ color: "text.secondary" }} gutterBottom>
                        If you have moved tasks in any part of your plan, all of those changes will be relative to the
                        new date you specify, this has consequences and if you want more information please contact
                        support.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Do you wish to proceed and unlock the plan date?
                    </Typography>
                </Box>,
                <Typography variant="inherit" sx={{ color: "warning.dark" }}>
                    CAUTION: Moving plan start date
                </Typography>
            )
        ) {
            setLocked(false)
        }
    }
}
